<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Edit User</h1>
        <p class="user-mgmt-page__subtitle">Update user details, permissions, and recommended sessions.</p>
      </div>
    </header>

    <form #rpform="ngForm">
      <section class="user-mgmt-page__form-card">
        <mat-tab-group>
          <mat-tab label="Tab 1" tabindex="0">
            <ng-template mat-tab-label>Details</ng-template>
            <div class="user-mgmt-page__card-body">
              <app-edit-user-form [updateUser]="updateUser" [applicationRoles]="applicationRoles"></app-edit-user-form>
            </div>
          </mat-tab>

          @if (updateUser.isSpecialPermissionsVisible) {
            <mat-tab label="Tab 2" tabindex="1">
              <ng-template mat-tab-label>Special Permissions</ng-template>
              <div class="user-mgmt-page__card-body">
                <app-user-course-list [updateUser]="updateUser" type="SPECIALPERMISSION"></app-user-course-list>
              </div>
            </mat-tab>
          }

          @if (updateUser.isRecommendedSessionVisible) {
            <mat-tab label="Tab 3" tabindex="2">
              <ng-template mat-tab-label>Recommended Course/Sessions</ng-template>
              <div class="user-mgmt-page__card-body">
                <app-user-course-list [updateUser]="updateUser" type="RECOMMENDEDSESSION"></app-user-course-list>
              </div>
            </mat-tab>
          }
        </mat-tab-group>

        <div class="user-mgmt-page__footer-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" (click)="udpateUser()">
            <mat-icon>save</mat-icon>
            Save Changes
          </button>
          <a routerLink="/user-list" class="user-mgmt-page__btn user-mgmt-page__btn--secondary">
            <mat-icon>close</mat-icon>
            Cancel
          </a>
        </div>
      </section>
    </form>
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
